import { useState } from "react";
import TrunkLeafNavigationContent from "./components/TrunkLeafNavigationContent";
import TrunkLeafNavigationContext, {
	TrunkLeafNavigationContextType,
} from "./contexts/TrunkLeafNavigationContext";
import { createTrunkLeafNavigationStore } from "./stores/trunkLeafNavigationStore";
import { TrunkLeafNavigationProps } from "./types";

const TrunkLeafNavigation = <TProps extends object>(props: TrunkLeafNavigationProps<TProps>) => {
	const [contextValue] = useState<TrunkLeafNavigationContextType>(() => ({
		store: createTrunkLeafNavigationStore({
			onNavigation: props.onNavigation,
		}),
	}));

	return (
		<TrunkLeafNavigationContext.Provider value={contextValue}>
			<TrunkLeafNavigationContent {...props} />
		</TrunkLeafNavigationContext.Provider>
	);
};
export default TrunkLeafNavigation;
